import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { startLogout } from '../actions/auth';

const dropdown = () => {
	document.getElementById("drop-down-menu").classList.toggle("show");
}


class Header extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			startLogout: this.props.startLogout,
			role: JSON.parse(sessionStorage.getItem('auth')).role,
			showMenu: this.props.showMenu
		}
	}

	partenaireFavicon() {
		if ( this.props.partenaireData.favicon64 != null ) {
			let head = document.getElementsByTagName("head")[0];
			var links = head.getElementsByTagName("link");
			for (var i=0; i<links.length; i++) {
				var link = links[i];
				if (link.type == "image/png" && link.rel == "icon") {
					head.removeChild(link);
				}
			}
			var link = document.createElement("link");
			link.type = "image/x-icon";
			link.rel = "icon";
			link.href = "data:image/x-icon;base64,"+this.props.partenaireData.favicon64;
			head.appendChild(link);
		}
	}

	render() {
		this.partenaireFavicon();

		let logoImg = this.props.partenaireData.marqueLogo64 != null ? this.props.partenaireData.marqueLogo64: '';
		const logoStyle = {
			maxWidth: '100%'
		};
		let Logo = ({ data }) => (<div className="logo" ><img src={`data:image/jpg;base64,${data}`} style={logoStyle} /></div>)
		const divStyle = {
			display: 'flex'
		};
		const menuStyle = this.state.showMenu ? {}: {display: 'none'};
		return (
			<div className="container header">
				<nav className="navbar navbar-light purpleLight">
					<div className="navbar-brand" style={divStyle}>
						<div className="logo ma">
							{ logoImg != '' &&
			        			<Logo data={logoImg} />
			        		}
						</div>
					</div>
					<div className="nav-menu" style={menuStyle}>
						{this.state.role !== 'MC' &&
							<ul className="navbar-nav">
								<li className="nav-item dropdown" onClick={dropdown}>
									<div className="nav-link dropdown-toggle">
										<span className="title"> MENU </span><img src='/images/togglebutton2.png' alt="" className="toggle-img" /></div>
								</li>
							</ul>
						}
						<div className="drop-down-menu dp-content" id='drop-down-menu'>
							<ul className="list-group list-group-flush">
								<Link to="/"><li className="list-group-item"> Page d'accueil </li></Link>
								<Link to="/profil"><li className="list-group-item"> Mon Profil </li></Link>
								<Link to="/convention-obseques"><li className="list-group-item"> Ma convention d'assistance</li></Link>
								<Link to="/charges-de-memoire"><li className="list-group-item">Mes chargés de mémoire</li></Link>
								<Link to="/mes-obseques"><li className="list-group-item">Mes obsèques</li></Link>
								<Link to="/informations-juridiques"><li className="list-group-item">Mes infos juridiques</li></Link>
								<Link to="/avis-deces"><li className="list-group-item">Mon avis de décès</li></Link>
							</ul>
						</div>
						<div className="logout-button" onClick={this.state.startLogout}></div>
					</div>
				</nav>
			</div>
		);
	}
};

const mapDispatchToProps = (dispatch) => ({
	startLogout: () => dispatch(startLogout())
});

const mapStateToProps = state => ({
	partenaireData: state.partenaireData
})

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js